"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[985],{

/***/ 49985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loginForm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(13706);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react-social-login-buttons/dist/index.js
var dist = __webpack_require__(56435);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react-social-login/dist/social-login.js
var social_login = __webpack_require__(80459);
var social_login_default = /*#__PURE__*/__webpack_require__.n(social_login);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/app/authForms/socialButtons/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  hr {\n    margin: 0 !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: -",
        "px;\n  font-size: 14px;\n  text-align: center;\n  border-radius: 50%;\n  line-height: 40px;\n  width: 40px;\n  height: 40px;\n  color: #fff;\n  background: #ccc;\n  margin: 0 auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  padding: ",
        "px 0 0;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: 50%;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    max-width: 375px; // Max-width set by Apple\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var OrBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11d5218c-0"
})(_templateObject());
var Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11d5218c-1"
})(_templateObject1(), styles/* LAYOUT.GUTTER */._.GUTTER);
var SocialBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11d5218c-2"
})(_templateObject2(), styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER);
var SocialButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-11d5218c-3"
})(_templateObject3());
var StyledSocialButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11d5218c-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/components/app/authForms/socialButtons/SocialButton.tsx









var Button = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Button, Component);
    var _super = (0,_create_super/* default */.Z)(Button);
    function Button() {
        (0,_class_call_check/* default */.Z)(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _props = this.props, children = _props.children, triggerLogin = _props.triggerLogin;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            onClick: triggerLogin
        }, this.props), {
            children: children
        }));
    };
    return Button;
}(react.Component);
/* harmony default export */ var socialButtons_SocialButton = (social_login_default()(Button));

;// CONCATENATED MODULE: ./src/components/app/authForms/socialButtons/appleLogin/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin: ",
        "px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledAppleButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7ae3dd7-0"
})(styles_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER / 4);

// EXTERNAL MODULE: ./src/constants/authentication.ts
var authentication = __webpack_require__(5125);
// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/components/app/authForms/socialButtons/appleLogin/index.tsx










function AppleLoginButton(param) {
    var onLogin = param.onLogin, onLoginFailure = param.onLoginFailure;
    var appleServiceId = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig.integrations.apple_service_id;
    });
    var route = (0,router.useRouter)();
    var initApple = (0,react.useCallback)(function() {
        window.AppleID.auth.init({
            clientId: appleServiceId,
            scope: "name email",
            redirectURI: window.location.origin,
            usePopup: true
        });
    }, [
        appleServiceId
    ]);
    var handleAppleLogin = (0,react.useCallback)(function(event) {
        var ref;
        var secret = encodeURIComponent(event.detail.authorization.code);
        var jwt = (0,auth/* getParsedJwt */.KF)(event.detail.authorization.id_token);
        var identifier = encodeURIComponent(jwt ? jwt.sub : "");
        var socialPayload = {
            // Required only for Apple
            redirect_uri: window.location.origin,
            // Base social data
            identifier: identifier,
            provider: "apple",
            secret: secret
        };
        var optionalUserDetails = {};
        // Apple only includes a user object on first log-in
        if ((ref = event.detail) === null || ref === void 0 ? void 0 : ref.user) {
            var ref1, ref2, ref3, ref4, ref5, ref6;
            optionalUserDetails = {
                // Include first and last name if they're returned
                first_name: (ref1 = event.detail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.name) === null || ref3 === void 0 ? void 0 : ref3.firstName,
                last_name: (ref4 = event.detail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.name) === null || ref6 === void 0 ? void 0 : ref6.lastName
            };
        }
        var payload = (0,_object_spread/* default */.Z)({}, socialPayload, optionalUserDetails, authentication/* DEFAULT_SOCIAL_EXTRA_PAYLOAD */.sq);
        onLogin(payload);
    }, [
        onLogin
    ]);
    var handleAppleFailure = (0,react.useCallback)(function(error) {
        var ref;
        if ((error === null || error === void 0 ? void 0 : (ref = error.detail) === null || ref === void 0 ? void 0 : ref.error) !== "popup_closed_by_user") {
            onLoginFailure(error);
        }
    }, [
        onLoginFailure
    ]);
    (0,react.useEffect)(function() {
        if (typeof window.AppleID !== "undefined") {
            initApple();
        }
        document.addEventListener("AppleIDSignInOnSuccess", handleAppleLogin);
        document.addEventListener("AppleIDSignInOnFailure", handleAppleFailure);
        return function() {
            document.removeEventListener("AppleIDSignInOnSuccess", handleAppleLogin);
            document.removeEventListener("AppleIDSignInOnFailure", handleAppleFailure);
        };
    }, [
        appleServiceId,
        handleAppleFailure,
        handleAppleLogin,
        initApple
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAppleButton, {
        id: "appleid-signin",
        "data-mode": "center-align",
        "data-type": "sign-in",
        "data-color": "black",
        "data-border": "false",
        "data-height": "40",
        "data-width": "100%",
        onClick: function() {
            // KA event
            (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
                name: events/* LOG_EVENTS.APPLE_LOGIN_CLICK */.yX.APPLE_LOGIN_CLICK,
                details: route.route
            });
        }
    });
}

// EXTERNAL MODULE: ./src/components/uielements/hr/index.ts
var hr = __webpack_require__(51912);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
;// CONCATENATED MODULE: ./src/components/app/authForms/socialButtons/index.tsx













function SocialButtons(param) {
    var onLogin = param.onLogin;
    var route = (0,router.useRouter)();
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig.integrations;
    }), facebook_app_id = ref.facebook_app_id, apple_service_id = ref.apple_service_id;
    var handleGoogleAndFacebookLogin = function(user) {
        // Google expects idToken while Facebook expects accessToken
        var secret = user._provider === "google" ? user._token.idToken : user._token.accessToken;
        var socialPayload = {
            identifier: user._profile.email,
            provider: user._provider,
            secret: secret
        };
        var payload = (0,_object_spread/* default */.Z)({}, socialPayload, authentication/* DEFAULT_SOCIAL_EXTRA_PAYLOAD */.sq);
        onLogin(payload);
    };
    var handleSocialLoginFailure = function(err) {
        errorReporter/* captureException */.Tb(err);
        console.error(err);
    };
    var buttonStyle = {
        fontSize: "16.5px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        borderRadius: "6px",
        fontFamily: "Helvetica"
    };
    if (!facebook_app_id && !apple_service_id) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialBox, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrBlock, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hr/* StyledHr */.n, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                            children: "OR"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSocialButtonContainer, {
                    children: [
                        facebook_app_id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(socialButtons_SocialButton, {
                            provider: "facebook",
                            appId: facebook_app_id,
                            onLoginSuccess: handleGoogleAndFacebookLogin,
                            onLoginFailure: handleSocialLoginFailure,
                            scope: "public_profile,email",
                            version: "v25.0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FacebookLoginButton, {
                                style: buttonStyle,
                                text: "Sign in with Facebook",
                                onClick: function() {
                                    // KA event
                                    (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
                                        name: events/* LOG_EVENTS.FACEBOOK_LOGIN_CLICK */.yX.FACEBOOK_LOGIN_CLICK,
                                        details: route.route
                                    });
                                }
                            })
                        }) : null,
                        apple_service_id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppleLoginButton, {
                            onLogin: onLogin,
                            onLoginFailure: handleSocialLoginFailure
                        }) : null
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/redux-form/es/Field.js + 10 modules
var Field = __webpack_require__(82415);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/reduxForm.js + 15 modules
var reduxForm = __webpack_require__(45900);
// EXTERNAL MODULE: ./src/validators/authValidators.ts
var authValidators = __webpack_require__(95228);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/index.ts + 3 modules
var form_fields = __webpack_require__(1851);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var form_fields_styles = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
;// CONCATENATED MODULE: ./src/components/app/authForms/loginForm/form.tsx












var LoginForm = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LoginForm, Component);
    var _super = (0,_create_super/* default */.Z)(LoginForm);
    function LoginForm() {
        (0,_class_call_check/* default */.Z)(this, LoginForm);
        return _super.apply(this, arguments);
    }
    var _proto = LoginForm.prototype;
    _proto.render = function render() {
        var _props = this.props, handleSubmit = _props.handleSubmit, onLogin = _props.onLogin, loading = _props.loading;
        var extraPayload = authentication/* DEFAULT_PASSWORD_LOGIN_EXTRA_PAYLOAD */.g7;
        var accessor = !loading ? "login.cta" : "login.cta_loading";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_fields_styles/* StyledGenericForm */.yO, {
            onSubmit: handleSubmit(function(values) {
                return onLogin(Object.assign(values, extraPayload));
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_fields_styles/* StyledGenericFieldset */.x, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                            children: "Login form"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_fields_styles/* StyledFormGroup */.dS, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        name: "identifier",
                                        type: "email",
                                        placeholder: "Email",
                                        autoComplete: "email",
                                        component: form_fields/* ReduxFormField */.H3,
                                        autoFocus: false
                                    }, "identifier")
                                }, "login-form-field-identifier"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_fields_styles/* StyledFormField */.Ll, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        name: "secret",
                                        type: "password",
                                        placeholder: "Password",
                                        autoComplete: "off",
                                        component: form_fields/* ReduxFormField */.H3,
                                        autoFocus: false
                                    }, "secret")
                                }, "login-form-field-password")
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton_styles/* StyledPrimaryButton */.D, {
                    "data-testid": "signin-button",
                    submitting: loading,
                    type: "submit",
                    style: {
                        width: "100%"
                    },
                    buttonTheme: "secondary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: accessor
                    })
                })
            ]
        });
    };
    return LoginForm;
}(react.Component);
/* harmony default export */ var loginForm_form = ((0,reduxForm/* default */.Z)({
    form: "login",
    validate: authValidators/* loginValidator */.a5
})(LoginForm));

// EXTERNAL MODULE: ./src/components/uielements/recaptcha/index.tsx
var recaptcha = __webpack_require__(18368);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var actions = __webpack_require__(45479);
// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/components/app/authForms/loginForm/index.tsx


















var LoginComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LoginComponent, Component);
    var _super = (0,_create_super/* default */.Z)(LoginComponent);
    function LoginComponent() {
        (0,_class_call_check/* default */.Z)(this, LoginComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            formValues: null,
            recaptchaRef: undefined
        };
        _this.loginFactory = function(formValues, captchaResponse) {
            // Respect the referrer ONLY if we're on the login page
            var referrer = (0,global/* parseReferrer */.PA)((router_default()));
            _this.props.onLogin(Object.assign({}, formValues, (0,_define_property/* default */.Z)({}, authentication/* CAPTCHA_CONFIG.FIELD_NAME */.i5.FIELD_NAME, captchaResponse)), referrer);
            // If we're using a captcha, reset the captcha
            if (captchaResponse) {
                var /** @TODO ensure that the ref is defined. */ // @ts-expect-error
                ref;
                (ref = _this.state.recaptchaRef) === null || ref === void 0 ? void 0 : ref.current.reset();
            }
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.checkReCaptcha = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(formValues) {
                var recaptchaRef, captchaResponse;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            recaptchaRef = _this1.state.recaptchaRef;
                            if (!(recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                recaptchaRef.current.executeAsync()
                            ];
                        case 1:
                            captchaResponse = _state.sent();
                            _this1.loginFactory(formValues, captchaResponse);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            _this1.loginFactory(formValues);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(formValues) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = LoginComponent.prototype;
    _proto.render = function render() {
        var _this = this;
        var loading = this.props.loading;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(loginForm_form, {
                    onLogin: this.checkReCaptcha,
                    loading: loading
                }),
                !(0,android/* isAndroidShell */.Y2)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButtons, {
                    onLogin: this.loginFactory
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(recaptcha/* default */.Z, {
                    onRef: function(recaptchaRef) {
                        return _this.setState({
                            recaptchaRef: recaptchaRef
                        });
                    },
                    forwardRef: this.state.recaptchaRef,
                    action: authentication/* CAPTCHA_CONFIG.API_ACTIONS.LOGIN */.i5.API_ACTIONS.LOGIN
                })
            ]
        });
    };
    return LoginComponent;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        loading: state.app.auth.loading
    };
};
var mapDispatchToProps = {
    onLogin: actions/* default.login */.Z.login
};
var connector = (0,es.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ var loginForm = (connector(LoginComponent));


/***/ }),

/***/ 95228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pt": function() { return /* binding */ editUserValidator; },
/* harmony export */   "a5": function() { return /* binding */ loginValidator; },
/* harmony export */   "f": function() { return /* binding */ guestUserValidator; }
/* harmony export */ });
/* harmony import */ var _utils_validation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78080);
/* harmony import */ var _constants_validation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38885);


var loginValidator = function(values) {
    var errors = {};
    if (!values.identifier) {
        errors.identifier = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.password) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.secret) {
        errors.secret = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    return errors;
};
var editUserValidator = function(values) {
    var errors = {};
    if (!values.first_name) {
        errors.first_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.last_name) {
        errors.last_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.email) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.email && !_constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX.EMAIL.test */ .mL.EMAIL.test(values.email)) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX_VALIDATION_STRINGS.EMAIL */ .r7.EMAIL;
    }
    if (!values.phone) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.phone && (0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__/* .invalidPhone */ .Dj)(values.phone)) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PHONE */ .xz.PHONE;
    }
    if (!values.zip_code) {
        errors.zip_code = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.zip_code && !_constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test */ .mL.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test(values.zip_code)) {
        errors.zip_code = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX_VALIDATION_STRINGS.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA */ .r7.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA;
    }
    if (values.password && values.password.length < 8) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PASSWORD_LENGTH */ .xz.PASSWORD_LENGTH;
    }
    if (values.password && values.password_confirmation !== values.password) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PASSWORD_MISMATCH */ .xz.PASSWORD_MISMATCH;
    }
    if (!values.password_confirmation) {
        errors.password_confirmation = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.password) {
        errors.password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.current_password) {
        errors.current_password = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    return errors;
};
var guestUserValidator = function(values) {
    var errors = {};
    if (!values.first_name) {
        errors.first_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.last_name) {
        errors.last_name = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (!values.email) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.email && !_constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX.EMAIL.test */ .mL.EMAIL.test(values.email)) {
        errors.email = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .REGEX_VALIDATION_STRINGS.EMAIL */ .r7.EMAIL;
    }
    if (!values.phone) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.REQUIRED */ .xz.REQUIRED;
    }
    if (values.phone && (0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__/* .invalidPhone */ .Dj)(values.phone)) {
        errors.phone = _constants_validation__WEBPACK_IMPORTED_MODULE_1__/* .VALIDATION_STRINGS.PHONE */ .xz.PHONE;
    }
    return errors;
};


/***/ })

}]);